import Tracker from '@openreplay/tracker';
import trackerAxios from '@openreplay/tracker-axios';
import trackerAssist from '@openreplay/tracker-assist'

let ortracker = null

// Comprobamos si estamos en localhost o preprod para no cargar el tracker
if (
    window.location.hostname !== '127.0.0.1'
    && window.location.hostname !== 'localhost'
    && window.location.hostname !== 'crm.preprod.koibox.cloud'
) {
    ortracker = new Tracker({
        projectKey: "vp6us2bbxcj6G7FWYThg",
        obscureTextEmails: false,
        obscureTextNumbers: false,
        obscureInputEmails: false,
        obscureInputDates: false,
        obscureInputNumbers: false
    });
    ortracker.use(trackerAxios({
        sanitiser: (data) => {
            if (data.url.includes('/login')) {
                data.request.body = null
            }
            if (data.url.includes('/registrar')) {
                data.request.body = null
            }

            return data
        }
    }))
    ortracker.use(trackerAssist())
}



export default ortracker;
